import React, { useEffect, useState } from "react";
import { getFirestore, doc, getDoc, deleteDoc } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../components/AuthContext";
import "./style.css";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const NoticeDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const docRef = doc(db, "notice", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setNotice(docSnap.data());
        } else {
          console.error("No such document!");
        }
      } catch (error) {
        console.error("Error fetching notice: ", error);
      }
    };

    fetchNotice();
  }, [id]);

  const handleDelete = async () => {
    const confirmDelete = window.confirm("정말 삭제하시겠습니까?");
    if (!confirmDelete) return;

    try {
      const docRef = doc(db, "notice", id);
      await deleteDoc(docRef);
      alert("글이 삭제되었습니다.");
      navigate("/notice");
    } catch (error) {
      console.error("Error deleting notice: ", error);
    }
  };

  const handleEdit = () => {
    navigate(`/admin/new`, {
      state: {
        id,
        title: notice.title,
        content: notice.content,
        imageUrl: notice.url || "", // 이미지 URL 기본값 처리
      },
    });
  };

  if (!notice) {
    return <p style={{ textAlign: "center", padding: "2em" }}>로딩 중...</p>;
  }

  return (
    <div>
      <div className="detail">
        <div className="detail_box">
          {isAuthenticated && (
            <div className="admin-buttons">
              <button onClick={handleEdit}>수정</button>
              <button onClick={handleDelete} style={{ backgroundColor: "#ff4747" }}>
                삭제
              </button>
            </div>
          )}
          <div className="date">{notice.date}</div>
          <div className="title">{notice.title}</div>
          <div className="content">{notice.content}</div>
          {notice.url && (
            <div className="image">
              <img src={notice.url} alt="첨부 이미지" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoticeDetail;